import { styled } from "@mui/material";
import { Checkbox0 } from "../Icons/Checkbox0";
import { Checkbox1 } from "../Icons/Checkbox1";

export const NotCheckedIcon = styled(Checkbox0)(({ theme }) => (
    theme.unstable_sx({
        width: "3.2rem",
        height: "3.2rem",
        color: theme.palette.grey[300],
    })
));

export const CheckedIcon = styled(Checkbox1)(({ theme }) => (
    theme.unstable_sx({
        width: "3.2rem",
        height: "3.2rem"
    })
));